module.exports = __webpack_public_path__ + "static/avatar_lg-d32272d8e95c096352645a577bd4e072.png";